
  export default {
    mounted() {
      this.el.addEventListener("click", (event) => {
        const control = event.target.closest("[data-reaction][data-message-id]")
        if (control) this.flip(control)
      })

      this.handleEvent("chat:reaction_refused", ({message_id, reaction}) => {
        const row = document.getElementById(`chat-reactions-${message_id}`)
        const chip = row && row.querySelector(`[data-reaction="${reaction}"]`)
        if (chip) this.toggleChip(row, chip)
      })
    },

    flip(control) {
      const row = document.getElementById(`chat-reactions-${control.dataset.messageId}`)
      if (!row) return

      const chip = row.querySelector(`[data-reaction="${control.dataset.reaction}"]`)

      if (chip) {
        this.toggleChip(row, chip)
      } else {
        this.addChip(row, control)
      }
    },

    toggleChip(row, chip) {
      const counter = chip.querySelector("[data-reaction-count]")
      const count = Number(counter.textContent)

      if (chip.dataset.mine === "true") {
        counter.textContent = count - 1
        chip.dataset.mine = "false"

        if (count <= 1) {
          chip.hidden = true
          if (!row.querySelector("[data-reaction]:not([hidden])")) row.classList.add("hidden")
        }
      } else {
        if (chip.hidden) row.appendChild(chip)
        counter.textContent = count + 1
        chip.dataset.mine = "true"
        chip.hidden = false
        row.classList.remove("hidden")
      }
    },

    addChip(row, control) {
      const template = document.getElementById("chat-chip-template")
      const chip = template.content.firstElementChild.cloneNode(true)
      const type = control.dataset.reaction

      chip.dataset.messageId = control.dataset.messageId
      chip.dataset.reaction = type
      chip.setAttribute("phx-value-message-id", control.dataset.messageId)
      chip.setAttribute("phx-value-reaction", type)
      chip.querySelector("[data-chip-glyph]").textContent = control.textContent.trim()
      chip.querySelector("[data-chip-label]").textContent = `reacted with ${type}`

      row.appendChild(chip)
      row.classList.remove("hidden")
    }
  }
